import React, { useEffect, useState } from "react";
import CardProduct from "../components/product/CardProduct";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
// import CheckoutForm from "../components/CheckoutForm";
import { useSelector } from "react-redux";
// import { useCountries } from "use-react-countries";
import {
  Button,
  Tab,
  TabPanel,
  Tabs,
  TabsBody,
  TabsHeader,
} from "@material-tailwind/react";
import { Textarea } from "@material-tailwind/react";
import api from "../api/api";
import { toast } from "react-toastify";
import { nanoid } from "nanoid";

import { useNavigate } from "react-router";
import { clearCart } from "../features/cart/cartSlice";
import { store } from "../store";
import { decrypt } from "../utils/CryptData";
import { ShoppingCartIcon } from "@heroicons/react/24/outline";
// import { useNavigate } from "react-router";

function Order() {
  const navigate = useNavigate();
  const { cartItems, total } = useSelector((state) => state.cartProduct);
  const loginState = useSelector((state) => state.auth.isLoggedIn);

  const [dataUser, setDataUser] = useState({});
  // const [isOpen, setIsOpen] = useState(false);
  // const [clientSecret, setClientSecret] = useState("");
  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [statePaiment, setStatePaiment] = useState(false);
  const [checkPaiment, setCheckPaiment] = useState(true);
  // const [, setDpmCheckerLink] = useState("");

  const shippingCost = 1000;

  // const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  const Headers = {
    headers: {
      "Content-type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${
        JSON.parse(decrypt(localStorage.getItem("dus"))).token
      }`,
    },
  };
  useEffect(() => {
    if (!loginState || !decrypt(localStorage.getItem("dus"))) {
      navigate("/");
    }

    setDataUser(
      ...(JSON.parse(decrypt(localStorage.getItem("dus"))).user ?? {})
    );
  }, [loginState, navigate]);

  // const options = {

  //   appearance: {
  //     theme: "flat",
  //   },
  //   clientSecret,
  // };

  const [shipping] = useState({
    shipping_method: "Standard",
    shipping_cost: shippingCost,
    tracking_number: `SUIVI${nanoid(10)}`,
  });

  const [formData, setFormData] = useState({
    customer_id: JSON.parse(decrypt(localStorage.getItem("dus"))).user[0].id,
    status: "en attente",
    total_price: total,
    payment_method: "",
    cartItems: cartItems,
  });
  useEffect(() => {
    setCheckPaiment(!(formData.shipping_address?.length > 1));
  }, [formData.shipping_address]);

  const infoUser = [
    { label: "Nom", value: dataUser.first_name },
    { label: "Prénom(s)", value: dataUser.last_name },
    { label: "Email", value: dataUser.email },
    { label: "Contact", value: dataUser.contact },
    { label: "Ville", value: dataUser.city },
    { label: "Adresse", value: dataUser.address },
  ];

  const data = [
    // {
    //   label: "Payé maintenant",
    //   value: "Carte",
    //   icon: Square3Stack3DIcon,
    //   desc: `It really matters and then like it really doesn't matter.
    //   What matters is the people who are sparked by it. And the people
    //   who are like offended by it, it doesn't matter.`,
    // },
    {
      label: "Payé à la livraison",
      value: "livraison",
      icon: ShoppingCartIcon,
      desc: `Because it's about motivating the doers. Because I'm here
      to follow my dreams and inspire other people to follow their dreams, too.`,
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("formData", formData);

    setIsProcessing(true);

    if (formData) {
      console.log("formData", formData);

      api
        .post("orders", JSON.stringify(formData), Headers)
        .then((data) => {
          toast.success("Commande effectué avec success");

          api.post("shipping", { ...shipping, order_id: data.data.id });
          api.post(
            "paiment/paiment-register",
            {
              order_id: data.data.id,
              payment_method: formData.payment_method,
              amount: total,
              status: "Terminé",
              products: { cartItems: cartItems, dataUser: dataUser },
            },
            Headers
          );

          api
            .post(
              "orders/orderItems",
              { cartItems: cartItems, order_id: data.data.id },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
            .then((data) => {
              api
                .post("inventory/decrease", cartItems, {
                  headers: {
                    "Content-Type": "application/json",
                  },
                })
                .then((data) => {
                  setStatePaiment(true);
                  setMessage("Payement réussit");
                });
            });
          store.dispatch(clearCart());
          navigate("/inventory");
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } else {
      setMessage("An unexpected error occured.");
    }

    setIsProcessing(false);
  };

  const handleTabChange = async (methode) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      payment_method: methode,
    }));
  };

  // useEffect(() => {
  //   // console.log("formData", formData);

  //   // Create PaymentIntent as soon as the page loads
  //   if (total && formData.payment_method.includes("Carte")) {

  //     api
  //       .post(
  //         "paiment/paiment-intent",
  //         JSON.stringify({ total }),
  //         {
  //           headers: { "Content-Type": "application/json" },
  //         }
  //       )

  //       .then((data) => {
  //         // console.log("data", data);

  //         setClientSecret(data.data.clientSecret);
  //         // [DEV] For demo purposes only
  //         setDpmCheckerLink(data.data.dpmCheckerLink);
  //       });
  //   }
  //   // else {
  //   //   toast.warn("Veuilez ajouter de nouveau produit")
  //   // }

  // }, [formData.payment_method, total]);

  return (
    <div className="md:flex  justify-center gap-10 p-2 my-12">
      <div className="md:shrink-0   basis-1/3 bg-white p-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 px-4">
          {infoUser.map(({ label, value }, index) => (
            <div key={index} className="mb-4">
              <div className="text-md font-bold mb-2 text-gray-700 dark:text-blue">
                {label}
              </div>
              <div className="font-semibold text-gray-900 dark:text-gray-300">
                {value}
              </div>
            </div>
          ))}
        </div>
        <div className="divider"></div>

        <Textarea
          label="Adresse de livraison"
          name="shipping_address"
          onChange={(e) =>
            setFormData((prevFormData) => ({
              ...prevFormData,
              shipping_address: e.target.value,
            }))
          }
          required
        />
        <Tabs value="livraison" className="mt-10">
          <TabsHeader>
            {data.map(({ label, value, icon }) => (
              <Tab
                key={value}
                value={value}
                disabled
                onClick={() => handleTabChange(value)}
              >
                <div className="flex items-center gap-2">
                  {React.createElement(icon, { className: "w-5 h-5" })}
                  {label}
                </div>
              </Tab>
            ))}
          </TabsHeader>
          <TabsBody>
            {data.map(({ value, desc }) => (
              <TabPanel key={value} value={value}>
                {(() => {
                  switch (value) {
                    // case "Carte":
                    //   return (
                    //     <>
                    //       {clientSecret && (
                    //         <Elements
                    //           stripe={stripePromise}
                    //           options={options}
                    //         >
                    //           <CheckoutForm dpmCheckerLink={dpmCheckerLink} formData={formData} shipping={shipping} />
                    //         </Elements>
                    //       )}
                    //     </>
                    //   );

                    case "livraison":
                      return (
                        <form
                          onSubmit={handleSubmit}
                          className="grid grid-rows-2 gap-y-8 mt-5 "
                        >
                          <span className="flex justify-center items-center gap-4">
                            <input
                              defaultChecked
                              type="radio"
                              name="radio-1"
                              className="radio"
                            />
                            <span>
                              Livraison à domicile(à partir de 1,000 FCFA)
                            </span>
                          </span>
                          <Button
                            disabled={checkPaiment}
                            id="submit"
                            type="submit"
                            className="w-1/2 mx-auto bg-blue-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-none"
                          >
                            <span id="button-text">
                              {isProcessing
                                ? "Processing ... "
                                : "Payé maintenant"}
                            </span>
                          </Button>
                          {statePaiment && (
                            <div
                              id="payment-message"
                              className="text-blue-600 text-2xl font-bold text-green-400 my-8 text-center"
                            >
                              {message}
                            </div>
                          )}
                        </form>
                      );
                    default:
                      return (
                        <div className="text-theme-11 text-3xl">
                          Indisponible pour le moment
                        </div>
                      );
                  }
                })()}
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
      </div>
      <div className="bg-white  h-1/2  right-10 pt-10 px-5">
        <div className="text-center  text-1/3 font-bold text-grey-200">
          Liste des produits du panier
        </div>
        {cartItems && <CardProduct product={cartItems} order="order" />}
        <div className="p-4 text-xl font-semi text-end">
          Total : {total} FCFA!
        </div>
      </div>
    </div>
  );
}

export default Order;
